import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { AvatarComponent } from '../../components/avatar/avatar.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ServiceRestServices from '../../services/service-rest.service';
import Toast from '../../services/toast.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-partner-contact-request',
	templateUrl: './modal-partner-contact-request.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, AvatarComponent, ItemErrorComponent, FormsModule ]
})
export class ModalPartnerContactRequestComponent implements OnInit {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private toast: Toast = inject(Toast);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogRef = inject(MatDialogRef<ModalPartnerContactRequestComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		this.vm.uid = 'partner-request-' + Date.now();
		this.vm.data = {};
		this.vm.close = this.close;
		this.vm.handleFormSubmit = this.handleFormSubmit;
	}
	
	handleFormSubmit(mainForm: any) {
		if (this.vm.processing) return;
		this.vm.submitted = true;
		if (mainForm.invalid) return;
		this.vm.processing = true;
		
		this.serviceRestServices.sendPartnerContactRequest(
			{ businessServiceId: this.vm.service.id },
			{ content: this.vm.data.content },
			() => {
				this.vm.processing = false;
				this.vm.sent = true;
			},
			() => {
				this.vm.processing = false;
				this.toast.show(this.angularFilterHelperService.translate('Partners.Contact.Send_Error'));
			}
		);
	}
	
	close() {
		this.dialogRef.close();
	}
	
}
